/* eslint-disable no-inline-comments */
// @flow
import imported from 'react-imported-component';
import { thenFunction } from '../../utils/imported';

export { BankQuestions, BankQuestionsCTA } from './BankQuestions';
export { BankThemeProvider } from './BankThemeProvider';
export { BankOnboardingCTA } from './BankOnboardingCTA';
export { BankManagers } from './BankManagers';
export { BankIntro } from './BankIntro';
export { BankProductsByType } from './BankProductsByType';
export { BankProductsHeader } from './BankProductsHeader';
export { BankProductFamilies } from './BankProductFamilies';
export { BankSmallArticle } from './BankSmallArticle';
export { BankPageContainer, BankSkeleton } from './BankSkeletons';
export { BankProductsCarousels } from './BankProductsCarousels';

export { getBankProductSubtypes } from './utils';

export const BankArticles = imported(() =>
  import(/* webpackChunkName: "Banks-BankArticles" */ './BankArticles').catch(() => thenFunction()));
export const BankHeader = imported(() =>
  import(/* webpackChunkName: "Banks-BankHeader" */ './BankHeader').catch(() => thenFunction()));
